import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsDetailsRoute: InvariantJiraRoute = {
	name: 'classic-software-details',
	path: '/jira/software/c/projects/:projectKey/settings/details',
	exact: true,
};
